import React, { CSSProperties } from 'react'
import { TabPaneProps, Tabs, TabsProps } from '@yuanfudao/metis-web-component'
import lessModule from './index.module.less'

export interface CommonListType {
  value: any,
  label: string,
}

export default function CustomTab2({
  dataSource,
  tabProps,
  tabPaneProps = {},
  wrapStyle,
  disabled,
  noBorder = true,
}: {
  dataSource: CommonListType[],
  tabProps: TabsProps,
  tabPaneProps?: TabPaneProps,
  wrapStyle?: CSSProperties,
  disabled?: boolean,
  noBorder?: boolean,
}) {
  return (
    <div className={`reset-tab2 ${lessModule.wrap} ${noBorder ? lessModule.noBorder : ''}`} style={wrapStyle}>
      <Tabs items={dataSource.map((i) => ({...i, key: i.value}))} {...tabProps}>
        {/* {
          dataSource.map((item) => (
            <Tabs.TabPane tab={item.label} key={item.value} {...tabPaneProps} />
          ))
        } */}
      </Tabs>
    </div>
  )
}
